export default {"src":"/_next/static/media/jaycar-logo.a95c232b.svg","height":40,"width":148,"blurWidth":0,"blurHeight":0};